import MultiColumnModule from "@/components/site-builder/MultiColumnModule";
import type { ColumnTextModuleType } from "./types";
import ColumnVariant1 from "./ColumnVariant1";

export interface ColumnTextModuleProps {
  module: ColumnTextModuleType;
}

export default function ColumnTextModule(props: ColumnTextModuleProps) {
  const { module } = props;
  const {
    body: { buttonsAlignment },
  } = module;

  return (
    <MultiColumnModule
      module={module}
      renderBlock={(block) => (
        <ColumnVariant1 block={block} buttonsAlignment={buttonsAlignment} />
      )}
    />
  );
}
